import React, { ReactElement, useEffect } from 'react';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import { useDataCollection } from '../../../../hooks';
import { floorCountOptions } from '../../../../data/enumerations';
import StepHeader from '../../../components/Layout/StepHeader';
import CheckCard from '../../../components/Form/CheckCard';
import { Form } from 'formik';

const StepHouseFloorCount = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.floorCount) {
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <div className="otz-main otz-main--house-floor">
                <StepHeader title="Kolik máte pater?" />
                <div className={'wiz-card wiz-card--small'}>
                    <div className={'wiz-card__inner wiz-card__inner-three'}>
                        {floorCountOptions.map((option) => {
                            return (
                                <div key={option.value} className={'wiz-card-item'}>
                                    <CheckCard
                                        name={'floorCount'}
                                        onChange={handleChange}
                                        checked={values.floorCount === option.value}
                                        value={option.value}
                                    >
                                        <div className={'check-card__inner'}>
                                            <div className={'check-card__image'}>
                                                <img src={option.img} alt={'img-' + option.value} />
                                            </div>
                                            <div className="check-card__text">
                                                <h3>{option.title}</h3>
                                                <p>{option.description}</p>
                                            </div>
                                        </div>
                                    </CheckCard>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepHouseFloorCount;
